"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillXY = void 0;
var fillXY = function (charts, gap) {
    var xys = charts.reduce(function (acc, it, i) {
        var lastXYH = i === 0 ? [0, 0, 0] : acc[acc.length - 1];
        acc.push([gap, lastXYH[1] + lastXYH[2] + gap - (it.offsetY ? it.offsetY : 0), it.height]);
        return acc;
    }, []);
    return charts.map(function (it, i) { return (__assign(__assign({}, it), { x: xys[i][0], y: xys[i][1] })); });
};
exports.fillXY = fillXY;
